import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';

import { useUpdateLibraryMutation } from '@classCreation/services/libraryService';
import Field from 'components/Field';
import Form from 'components/Form';
import Input from 'components/Input';
import LibraryResourceType from 'propTypes/libraryResourceType';

function EditLibraryForm({
  library,
  isEditing,
  setIsEditing,
  ...remainingProps
}) {
  const [updateLibrary, { error, isLoading: isUpdating, isSuccess, reset }] =
    useUpdateLibraryMutation();
  const [title, setTitle] = useState(library.title);

  useEffect(() => {
    setTitle(library.title);
  }, [library.title]);

  useEffect(() => {
    if (!isEditing) {
      setTitle(library.title);
      if (error) {
        reset();
      }
    }
  }, [error, isEditing, library.title, reset]);

  const handleTitleChange = useCallback((event) => {
    setTitle(event.target.value);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      setIsEditing(false);
    }
  }, [isSuccess, setIsEditing]);

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      updateLibrary({ id: library.id, title: title });
    },
    [library.id, title, updateLibrary]
  );

  return (
    <Form
      onSubmit={handleSubmit}
      serverErrors={error?.data?.errors}
      {...remainingProps}
    >
      <Field
        name="title"
        serverErrors={error?.data?.errors}
      >
        <Input
          required
          disabled={!isEditing}
          onChange={handleTitleChange}
          value={title}
        />
      </Field>
      {isEditing && (
        <Tappable
          disabled={isUpdating}
          type="submit"
          component="button"
          className="btn btn-primary btn-long m-b-l"
        >
          Update Library
        </Tappable>
      )}
    </Form>
  );
}

EditLibraryForm.propTypes = {
  library: LibraryResourceType.isRequired,
};

export default EditLibraryForm;
